import { ColorMode } from "./theme";

type ENVIRONMENT_TYPE = {
  [env: string]: {
    ENV: string;
    BE_BASE_URL: string;
    INT_BASE_URL: string;
    FE_BASE_URL: string;
    GSAT_BASE_URL: string;
    FLOW_HOST: string;
    MINHA_FAMILIA_URL: string;
    GA_TRACKER_ID: string;
    COOKIE_DOMAIN_GA: string;
    OIDC_URL: string;
    OIDC_LEGACY_COMPATIBLE: boolean;
    ALF_CLIENT: string;
    ALF_CLIENT_INTERNATIONAL: string;
    ALF_SERVICE_ID_INTERNATIONAL: string;
    DEFAULT_REDIRECT_URL: string;
    SALES_HOST: string;
    CLARO_PROVIDER_ID: string;
    CLARO_SERVICE_ID: string;
    ALLOWED_REDIRECT_HOSTS: string[];
    ALLOWED_ACTION_HOSTS: string[];
    TERMS_OF_USE_URL: string;
    PRIVACY_POLICY_URL: string;
    THEME_MODE: ColorMode;
    SENTRY_DSN: string;
  };
};

const ENVIRONMENT: ENVIRONMENT_TYPE = {
  local: {
    ENV: "local",
    BE_BASE_URL: "http://globoid.local.globoi.com:81",
    INT_BASE_URL: "http://globoid.local.globoi.com:80",
    FE_BASE_URL: "http://globoid.local.globoi.com:3000",
    GSAT_BASE_URL: "https://gsatmulti.dev.globoi.com",
    FLOW_HOST: "https://login.dev.globoi.com",
    MINHA_FAMILIA_URL: "https://minhafamilia.qa.globoi.com",
    GA_TRACKER_ID: "UA-110089742-5",
    COOKIE_DOMAIN_GA: "localhost",
    OIDC_URL: "https://id.dev.globoi.com/auth",
    OIDC_LEGACY_COMPATIBLE: false,
    ALF_CLIENT: "alf@apps.globoid",
    ALF_CLIENT_INTERNATIONAL: "alf-internacional-qa@apps.globoid",
    ALF_SERVICE_ID_INTERNATIONAL: "6828",
    DEFAULT_REDIRECT_URL: "https://globo.com",
    SALES_HOST: "https://partners-uat1.sales.qa.globoi.com",
    CLARO_PROVIDER_ID: "4f08ffb7-3315-43db-9ab1-6804ba5621a6",
    CLARO_SERVICE_ID: "7049",
    ALLOWED_REDIRECT_HOSTS: [
      "localhost",
      "127.0.0.1",
      "globoid.local.globoi.com",
      "globo.com",
      "globoi.com"
    ],
    ALLOWED_ACTION_HOSTS: [
      "localhost",
      "127.0.0.1",
      "globoid.local.globoi.com"
    ],
    TERMS_OF_USE_URL: "https://login.qa.globoi.com/termosUso/",
    PRIVACY_POLICY_URL:
      "https://privacidade.qa.globoi.com/int/pt-br/politica-de-privacidade/",
    THEME_MODE: (process.env.REACT_APP_THEME_MODE || "light") as ColorMode,
    SENTRY_DSN: ""
  },

  local_qa: {
    ENV: "local_qa",
    BE_BASE_URL: "http://be.alf-be.qa.globoi.com",
    INT_BASE_URL: "http://be.alf-int.qa.globoi.com",
    FE_BASE_URL: "https://alf.qa.globoi.com",
    GSAT_BASE_URL: "http://gsatmulti.qa.globoi.com",
    FLOW_HOST: "http://login.qa.globoi.com",
    MINHA_FAMILIA_URL: "http://minhafamilia.qa.globoi.com",
    GA_TRACKER_ID: "UA-110089742-5",
    COOKIE_DOMAIN_GA: "alf.qa.globoi.com",
    OIDC_URL: "https://goidc.authentication.qa.globoi.com/auth",
    OIDC_LEGACY_COMPATIBLE: true,
    ALF_CLIENT: "alf@apps.globoid",
    ALF_CLIENT_INTERNATIONAL: "alf-internacional-qa@apps.globoid",
    ALF_SERVICE_ID_INTERNATIONAL: "6828",
    DEFAULT_REDIRECT_URL: "https://globo.com",
    SALES_HOST: "https://partners-uat1.sales.qa.globoi.com",
    CLARO_PROVIDER_ID: "4f08ffb7-3315-43db-9ab1-6804ba5621a6",
    CLARO_SERVICE_ID: "7049",
    ALLOWED_REDIRECT_HOSTS: ["qa.globoi.com", "globo.com", "globoi.com"],
    ALLOWED_ACTION_HOSTS: ["alf.qa.globoi.com"],
    TERMS_OF_USE_URL: "https://login.qa.globoi.com/termosUso/",
    PRIVACY_POLICY_URL:
      "https://privacidade.qa.globoi.com/int/pt-br/politica-de-privacidade/",
    THEME_MODE: (process.env.REACT_APP_THEME_MODE || "light") as ColorMode,
    SENTRY_DSN: ""
  },

  dev: {
    ENV: "dev",
    BE_BASE_URL: "https://alf-be.dev.globoi.com",
    INT_BASE_URL: "https://alf-int.dev.globoi.com",
    FE_BASE_URL: "https://alf.dev.globoi.com",
    GSAT_BASE_URL: "https://gsatmulti.dev.globoi.com",
    FLOW_HOST: "https://login.qa.globoi.com",
    MINHA_FAMILIA_URL: "https://minhafamilia.qa.globoi.com",
    GA_TRACKER_ID: "UA-110089742-5",
    COOKIE_DOMAIN_GA: "alf.dev.globoi.com",
    OIDC_URL: "https://goidc.authentication.qa.globoi.com/auth",
    OIDC_LEGACY_COMPATIBLE: true,
    ALF_CLIENT: "alf@apps.globoid",
    ALF_CLIENT_INTERNATIONAL: "alf-internacional-qa@apps.globoid",
    ALF_SERVICE_ID_INTERNATIONAL: "6828",
    DEFAULT_REDIRECT_URL: "https://globo.com",
    SALES_HOST: "https://partners-uat1.sales.qa.globoi.com",
    CLARO_PROVIDER_ID: "4f08ffb7-3315-43db-9ab1-6804ba5621a6",
    CLARO_SERVICE_ID: "7049",
    ALLOWED_REDIRECT_HOSTS: [
      "dev.globoi.com",
      "qa.globoi.com",
      "globo.com",
      "globoi.com"
    ],
    ALLOWED_ACTION_HOSTS: ["alf.dev.globoi.com"],
    TERMS_OF_USE_URL: "https://login.qa.globoi.com/termosUso/",
    PRIVACY_POLICY_URL:
      "https://privacidade.qa.globoi.com/int/pt-br/politica-de-privacidade/",
    THEME_MODE: (process.env.REACT_APP_THEME_MODE || "light") as ColorMode,
    SENTRY_DSN: ""
  },

  qa: {
    ENV: "qa",
    BE_BASE_URL: "https://be.alf-be.qa.globoi.com",
    INT_BASE_URL: "https://alf-int.qa.globoi.com",
    FE_BASE_URL: "https://alf.qa.globoi.com",
    GSAT_BASE_URL: "https://gsatmulti.qa.globoi.com",
    FLOW_HOST: "https://login.qa.globoi.com",
    MINHA_FAMILIA_URL: "https://minhafamilia.qa.globoi.com",
    GA_TRACKER_ID: "UA-110089742-5",
    COOKIE_DOMAIN_GA: "alf.qa.globoi.com",
    OIDC_URL: "https://goidc.authentication.qa.globoi.com/auth",
    OIDC_LEGACY_COMPATIBLE: true,
    ALF_CLIENT: "alf@apps.globoid",
    ALF_CLIENT_INTERNATIONAL: "alf-internacional-qa@apps.globoid",
    ALF_SERVICE_ID_INTERNATIONAL: "6828",
    DEFAULT_REDIRECT_URL: "https://globo.com",
    SALES_HOST: "https://partners-uat1.sales.qa.globoi.com",
    CLARO_PROVIDER_ID: "4f08ffb7-3315-43db-9ab1-6804ba5621a6",
    CLARO_SERVICE_ID: "7049",
    ALLOWED_REDIRECT_HOSTS: ["qa.globoi.com", "globo.com", "globoi.com"],
    ALLOWED_ACTION_HOSTS: ["alf.qa.globoi.com"],
    TERMS_OF_USE_URL: "https://login.qa.globoi.com/termosUso/",
    PRIVACY_POLICY_URL:
      "https://privacidade.qa.globoi.com/int/pt-br/politica-de-privacidade/",
    THEME_MODE: (process.env.REACT_APP_THEME_MODE || "light") as ColorMode,
    SENTRY_DSN:
      "https://1b08bedaeb6557b9d1d8248146aaa111@sentry.globoi.com/1209"
  },

  prod: {
    ENV: "prod",
    BE_BASE_URL: "https://alf-be.globo.com",
    INT_BASE_URL: "https://alf-int.globo.com",
    FE_BASE_URL: "https://alf.globo.com",
    GSAT_BASE_URL: "https://gsatmulti.globo.com",
    FLOW_HOST: "https://login.globo.com",
    MINHA_FAMILIA_URL: "https://minhafamilia.globo.com",
    GA_TRACKER_ID: "UA-296593-6",
    COOKIE_DOMAIN_GA: "alf.globo.com",
    OIDC_URL: "https://goidc.globo.com/auth",
    OIDC_LEGACY_COMPATIBLE: true,
    ALF_CLIENT: "alf@apps.globoid",
    ALF_CLIENT_INTERNATIONAL: "alf-internacional@apps.globoid",
    ALF_SERVICE_ID_INTERNATIONAL: "6828",
    DEFAULT_REDIRECT_URL: "https://globo.com",
    SALES_HOST: "https://partners.sales.globo.com",
    CLARO_PROVIDER_ID: "4f08ffb7-3315-43db-9ab1-6804ba5621a6",
    CLARO_SERVICE_ID: "7049",
    ALLOWED_REDIRECT_HOSTS: ["globo.com"],
    ALLOWED_ACTION_HOSTS: ["alf.globo.com"],
    TERMS_OF_USE_URL: "https://login.globo.com/termosUso/",
    PRIVACY_POLICY_URL:
      "https://privacidade.globo.com/int/pt-br/politica-de-privacidade/",
    THEME_MODE: (process.env.REACT_APP_THEME_MODE || "light") as ColorMode,
    SENTRY_DSN:
      "https://1b08bedaeb6557b9d1d8248146aaa111@sentry.globoi.com/1209"
  }
};

export const featureFlags = {
  VERIFY_ASSOCIATION:
    process.env.REACT_APP_VERIFY_ASSOCIATION == "true" || false
};

const env = process.env.REACT_APP_ENV || "prod";

export default { ...ENVIRONMENT[env] };
